// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"926f14b55b","253":"983fbe4a09","619":"4c7d5377e7"}[chunkId] + ".js";
};